import React, {useEffect, useState, useMemo} from "react";
import InputAtm from "../../../../atomic/Input/Input";
import {Grid} from "@material-ui/core";
import moment from "moment";
import {isDefined} from "../../../../../utils";
import {useTranslation} from "react-i18next";

function calculatePolicyPrice(basePrice, policy) {
    if (!policy || !basePrice) return null;

    const numPrice = parseFloat(basePrice);
    if (isNaN(numPrice)) return null;

    if (!Number(policy.is_affected_price)) return numPrice;

    const affectValue = parseFloat(policy.affect_price_value);
    if (isNaN(affectValue)) return numPrice;

    let adjustedPrice = numPrice;

    if (policy.affect_price_action_type === "DEC") {
        if (policy.affect_price_type === "PER") {
            adjustedPrice = numPrice - (numPrice * affectValue / 100);
        } else if (policy.affect_price_type === "FIX") {
            adjustedPrice = numPrice - affectValue;
        }
    } else if (policy.affect_price_action_type === "INC") {
        if (policy.affect_price_type === "PER") {
            adjustedPrice = numPrice + (numPrice * affectValue / 100);
        } else if (policy.affect_price_type === "FIX") {
            adjustedPrice = numPrice + affectValue;
        }
    }

    return Math.max(0, Math.round(adjustedPrice * 100) / 100);
}

export default function Price(props) {
    useEffect(() => {},[]);

    const { t } = useTranslation();
    const {key, value, stop_sell} = props.value
    const {updatedData} = props

    const [price, setPrice] = useState( updatedData !== undefined && updatedData.hasOwnProperty(key) ? updatedData[key] : value);
    const [hasData, setHasData] = useState(updatedData !== undefined && updatedData.hasOwnProperty(key) ? true : false);
    const [disabled, setDisabled] = useState(stop_sell);

    const onChange = event => {
        let newPrice = event.target.value;
        let priceKey = event.target.name;
        setPrice( newPrice );
        setHasData (false);
        props.onChangeUpdateData(priceKey, newPrice);
    };

    const disabledKey = key.split('_');
    const disabledKeyMerge = "STS_" + disabledKey[1] + "_" + disabledKey[2] + "_" + disabledKey[3] + "_" + disabledKey[4];

    useEffect( () => {
        if (Object.keys(updatedData).some(item => disabledKeyMerge === item)) {

            if (updatedData[disabledKeyMerge] === 1) {
                setDisabled(true)
            } else {
                setDisabled(false)
            }
        }

    },[updatedData])

    const policyPrices = useMemo(() => {
        if (!props.cancellationPolicies || !props.cancellationPolicies.length) return [];
        const currentPrice = updatedData !== undefined && updatedData.hasOwnProperty(key) ? updatedData[key] : price;
        const dateStr = moment(props.date).format("YYYY-MM-DD");

        return props.cancellationPolicies.map(policy => {
            const isInDateRange = Number(policy.is_date_range) === 1 &&
                policy.start_date && policy.finish_date &&
                dateStr >= policy.start_date && dateStr <= policy.finish_date;
            const isDefault = !policy.is_date_range || Number(policy.is_date_range) === 0;

            if (!isInDateRange && !isDefault) return null;

            const calculated = calculatePolicyPrice(currentPrice, policy);
            const color = Number(policy.is_nonrefundable) === 1 ? '#e74c3c' : '#888';
            return calculated !== null ? { value: calculated, color } : null;
        });
    }, [props.cancellationPolicies, props.date, price, updatedData, key]);

    return (
        <Grid className={`${(moment(props.date).locale('de').weekday() == 5 || moment(props.date).locale('de').weekday() == 6 ) ? 'weekend-inputs' : ""} inventory-price t-center`}>
            <InputAtm
                name={key}
                placeholder="-"
                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, '') }}
                min={1}
                value={price}
                className={(hasData && isDefined(price)) ? "has-value-inventory type-number-hidden" : "type-number-hidden"}
                onChange={onChange}
                title={disabled ? t('btn-stop_sell') : ""}
                disabled={disabled}
            />
            {policyPrices.map((pp, idx) => (
                pp !== null ? (
                    <p key={idx} className="inventory-policy-price" style={{fontSize: '11px', color: pp.color, marginTop: '16px', lineHeight: '14px', fontWeight: '600'}}>
                        {pp.value}
                    </p>
                ) : (
                    <p key={idx} className="inventory-policy-price" style={{fontSize: '11px', color: '#888', marginTop: '16px', lineHeight: '14px', fontWeight: '600'}}>-</p>
                )
            ))}
            <p className={`${(moment(props.date).locale('de').weekday() == 5 || moment(props.date).locale('de').weekday() == 6 ) && (isDefined(props.channelAvailability) && props.channelAvailability.id === 3 ? "guaranteed-weekend-radius" : isDefined(props.channelAvailability) && props.channelAvailability.id === 2 ? "weekend-radius-limited" : 'weekend-radius')} null-inventory`}> &nbsp;</p>
        </Grid>
    );
}
